import { gql } from "graphql-tag"

import news from "./news"
import newsSource from "./newsSource"
import outlet from "./outlet"

export default gql`
  ${news}
  ${newsSource}
  ${outlet}
`
